import { gql } from "@apollo/client";

export const GET_FILE_METADATA = gql`
  query getFileUploadMetadata($systemId: Int, $fileStatus: String) {
    getFileUploadMetadata(systemId: $systemId, fileStatus: $fileStatus) {
      fileId
      recordId
      systemId
      pwsNumber
      systemName
      fileName
      fileType
      fileDescription
      fileSize
      ddwFileType
      fileTypeDescription
      ddwNotes
      ddwFileSubtype
      ddwFileSubtypeDescription
      fileStatus
      filePath
      assignedTo {
        recordId
        fileTypeDescription
        email
        firstName
        lastName
        sendType
      }
      gis
      lslCert
      isSystemRep
      createdOn
      createdBy
      lastUpdatedOn
      lastUpdatedBy
    }
  }
`;

export const LOAD_FILE_UPLOAD_REVIEW_DATA = gql`
  query FileMenu {
    getFileUploadFileTypes {
      value
      label
    }
    getListofDocSubTypesForDropdown {
      label
      value
      pkId
    }
    getWaterSystemMenu {
      value
      label
    }
    getAcceptRejectPending {
      value
      label
    }
  }
`;
export const UPDATE_FILE = gql`
  mutation updateFileUploadMetadata(
    $fileId: Int!
    $systemId: Int!
    $pwsNumber: String!
    $ddwFileType: Int!
    $ddwFileSubtype: Int
    $ddwNotes: String
    $filePath: String
    $fileStatus: String!
    $fileName: String!
    $lastUpdatedBy: String!
    $createdBy: String!
    $isDeleted: Boolean!
    $isSystemRep: Boolean
    $lslCert: Boolean
    $gis: Boolean
    $fileUploadDate: Date!
  ) {
    updateFileUploadMetadata(
      UpdateFileUpload: {
        fileId: $fileId
        systemId: $systemId
        pwsNumber: $pwsNumber
        ddwFileType: $ddwFileType
        ddwFileSubtype: $ddwFileSubtype
        ddwNotes: $ddwNotes
        filePath: $filePath
        fileStatus: $fileStatus
        fileName: $fileName
        lastUpdatedBy: $lastUpdatedBy
        createdBy: $createdBy
        isDeleted: $isDeleted
        isSystemRep: $isSystemRep
        lslCert: $lslCert
        gis: $gis
        fileUploadDate: $fileUploadDate
      }
    ) {
      fileId
      systemName
      systemId
      pwsNumber
      fileType
      ddwFileType
      fileTypeDescription
      ddwFileSubtype
      ddwFileSubtypeDescription
      ddwNotes
      fileName
      fileSize
      fileDescription
      filePath
      fileStatus
      lslCert
      isSystemRep
      gis
      createdOn
      createdBy
      lastUpdatedBy
      lastUpdatedOn
    }
  }
`;
